import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldWrapper, Switch, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { useCallback, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { emptyVisibilityCondition } from './constants';
const genericDescription = 'Toggle whether to conditionally show this attribute to agents.';
const entityDescription = {
    conversation: `${genericDescription} Based on the value of another custom attribute or a conversation property.`,
};
/** Represents the field for managing options of a custom select attribute. */
export const ToggleVisibilityFormField = ({ entityId, }) => {
    var _a;
    // TODO: [TEAMS-13693] add `AttributeFormFieldValuesHavingOptions` generic back after updating to RHF v8
    const { control, setValue } = useFormContext();
    const visibilityCondition = useWatch({
        control: control,
        name: 'visibility_condition',
    });
    const isRequiredToFill = useWatch({
        control: control,
        name: 'is_required',
    });
    const visibilityConditionEnabled = visibilityCondition !== null;
    const toggleVisibility = useCallback(() => {
        if (visibilityConditionEnabled) {
            // set visibility condition to null
            setValue('visibility_condition', null);
        }
        else {
            // set visibility condition to empty condition
            setValue('visibility_condition', emptyVisibilityCondition);
        }
    }, [setValue, visibilityConditionEnabled]);
    useEffect(() => {
        // set visibility condition empty if it the attribute is Required (We don't support both at the same time).
        if (isRequiredToFill && visibilityConditionEnabled) {
            setValue('visibility_condition', null);
        }
    }, [isRequiredToFill, setValue, visibilityConditionEnabled]);
    return (_jsxs(FieldWrapper, Object.assign({ label: "Toggle conditional visibility", labelFor: "toggle_visibility" }, { children: [_jsx(Box, Object.assign({ padding: "0 0 250" }, { children: _jsx(Text.Paragraph, Object.assign({ variant: "4", subdued: true }, { children: (_a = entityDescription[entityId]) !== null && _a !== void 0 ? _a : genericDescription })) })), _jsx(Tooltip, Object.assign({ content: "Cannot set conditional visibility if field is required to fill", disabled: !isRequiredToFill, dark: true }, { children: _jsx(Switch, { checked: visibilityConditionEnabled, disabled: isRequiredToFill, onChange: toggleVisibility, name: "toggle_visibility", value: "toggle_visibility" }) }))] })));
};
